<template>
  <ThemeDefaultContainerSection>
    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-11">
      <!-- Left Image Section -->
      <div class="tw-w-full lg:tw-w-5/12 tw-flex tw-items-center">
        <MediaImageLazyLoad
          :src="modelValue.content.image?.large || ''"
          :placeholder-src="modelValue.content.image?.tiny || ''"
          :alt="modelValue.content.title"
          custom-class="tw-rounded-xl"
          class="tw-hidden lg:tw-block tw-w-full tw-h-auto"
          seo-optimize
        />
      </div>

      <!-- Right Content Section -->
      <div class="tw-w-full lg:tw-w-7/12 tw-flex tw-flex-col">
        <h1
          class="tw-text-mb-xxl lg:tw-text-dt-xxl tw-text-center lg:tw-text-left"
        >
          {{ modelValue.content.title }}
        </h1>
        <MediaImageLazyLoad
          :src="modelValue.content.image?.large || ''"
          :placeholder-src="modelValue.content.image?.tiny || ''"
          :alt="modelValue.content.title"
          custom-class="tw-rounded-xl"
          class="tw-block lg:tw-hidden tw-w-full tw-h-auto tw-mt-4"
          seo-optimize
        />
        <DisplayHTMLContent
          class="introduce-html-content tw-mt-4"
          :model-value="modelValue.content.description"
        />
        <div class="tw-mt-8 tw-text-center md:tw-text-left">
          <!-- Button for YouTube -->
          <ButtonPrimary
            v-if="
              modelValue.content.showButton &&
              modelValue.content.buttonType === 'youtube'
            "
            class="!tw-w-[150px] !tw-h-12 hover:-tw-translate-y-1 tw-duration-500 tw-text-dt-button tw-rounded-lg"
            @click="
              showVideo(
                modelValue.content.buttonLink,
                modelValue.content.buttonName,
              )
            "
          >
            {{ modelValue.content.buttonName }}
          </ButtonPrimary>
          <!-- External Link -->
          <ButtonExternalLink
            v-if="
              modelValue.content.showButton &&
              modelValue.content.buttonType === 'url'
            "
            :title="modelValue.content.buttonName"
            :link="modelValue.content.buttonLink"
            class="!tw-w-auto !tw-h-12"
            @click="
              eventHomeButton(
                modelValue.content.buttonLink,
                modelValue.content.buttonName,
              )
            "
          />
        </div>
        <!-- Video Modal -->
        <MediaVideoModal
          v-if="
            modelValue.content.showButton &&
            modelValue.content.buttonType === 'youtube'
          "
          v-model="showVideoModal"
          :youtube-url="modelValue.content.buttonLink"
          video-width="tw-w-full"
          video-height="tw-aspect-video"
          custom-video-player="tw-rounded-xl"
          :container-style="{ width: '90vw', maxWidth: '1024px' }"
        />
      </div>
    </div>
  </ThemeDefaultContainerSection>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<Introduce>>,
    required: true,
  },
});

const { showVideoModal, showVideo, eventHomeButton } = useIntroduceSection();
</script>
